// Get average review score and last review item from Yotpo
function getYotpoReviewsInfo(productId, callback) {
  $.getJSON(`https://api.yotpo.com/v1/widget/8tqEhmg1uCL747UIka6ea7SyOe2XU0j4RyxKoeLL/products/${productId}/reviews.json`)
  .done(function (data) {
    if (data.response && data.response.reviews && data.response.reviews.length > 0) {
      let reviews = data.response.reviews;

      reviews.sort(function (a, b) {
        return new Date(b.created_at) - new Date(a.created_at);
      });

      reviews[0].created_at = new Date(reviews[0].created_at)

      callback({
        allReviews: reviews,
        averageReview: data.response.bottomline.average_score
      });
    } else {
      callback({
        allReviews: false,
        averageReview: false
      });
     }
  });
}
